import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import ShortTermExtension from './ShortTermExtension'
import LongTermExtension from './LongTermExtension'
import { useParams } from 'react-router-dom'
import { useReduxSelector } from 'store'
import React from 'react'

interface RentalExtensionProps { }

const RentalExtension: React.FC<RentalExtensionProps> = () => {
  const { id } = useParams<warehouse.PageParams>()
  const warehouse = useReduxSelector(state => selectWarehouse(state, id))
  if (warehouse?.isShortTerm) return <ShortTermExtension warehouse={warehouse} />
  return <LongTermExtension warehouse={warehouse} />
}

export default RentalExtension